import { useInicioTemplate } from "./useInicioTemplate";
import { Container } from "../../Atoms/Container";
import { NewSchedulingCard } from "./components/NewSchedulingCard";
import { BatchSchedulingBanner } from "./components/BatchSchedulingBanner";
import { MySchedulesCard } from "./components/MySchedulesCard";

export const InicioTemplate = () => {
  const {
    primeiroNome,
    handleMeusAgendamentos,
    handleNovoAgendamento,
    isCustomsBrokers,
    handleAgendamentoLote,
  } = useInicioTemplate();

  return (
    <Container>
      <div className="mx-auto w-full max-w-6xl">
        <div className="border border-solid border-[#E1E7E4] rounded-[100px] w-fit flex py-[5px] px-[10px] gap-[10px] mb-8">
          <img src="/assets/svgs/icon-star-blue.svg" alt="icone estrela" />
          <p className="text-[10px]">BEM-VINDO</p>
        </div>
        <div className="mb-12">
          <h1 className="text-4xl mb-2 md:text-[56px] font-bold md:mb-8">
            Olá, {primeiroNome}
          </h1>
          <h2 className="text-2xl md:text-[52px] font-semibold text-[#4D514F]">
            O que vamos fazer hoje?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <MySchedulesCard
            className="col-span-1"
            onAccess={handleMeusAgendamentos}
          />
          <NewSchedulingCard
            className="col-span-1 md:col-span-2"
            onAccess={handleNovoAgendamento}
          />
          {isCustomsBrokers && (
            <BatchSchedulingBanner
              className="col-span-1 md:col-span-3"
              onAccess={handleAgendamentoLote}
            />
          )}
        </div>
      </div>
    </Container>
  );
};
